export default {
  name: 'en-US',
  el: {
    name: 'Name',
    tel: 'Phone',
    save: 'Save',
    clear: 'Clear',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    loading: 'Loading...',
    noMore: 'No more',
    noCoupon: 'No coupons',
    nameEmpty: 'Please fill in the name',
    addContact: 'Add contact',
    telInvalid: 'Malformed phone number',
    xzxCalendar: {
      end: 'End',
      start: 'Start',
      title: 'Calendar',
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      monthTitle: (year: number, month: number) => `${year}/${month}`,
      rangePrompt: (maxRange: number) => `Choose no more than ${maxRange} days`,
    },
    xzxCascader: {
      select: 'Select',
    },
    xzxPagination: {
      prev: 'Previous',
      next: 'Next',
    },
    xzxPullRefresh: {
      pulling: 'Pull to refresh...',
      loosing: 'Loose to refresh...',
    },
    xzxSubmitBar: {
      label: 'Total:',
    },
    xzxCoupon: {
      unlimited: 'Unlimited',
      discount: (discount: number) => `${discount * 10}% off`,
      condition: (condition: number) => `At least ${condition}`,
    },
    xzxCouponCell: {
      title: 'Coupon',
      count: (count: number) => `You have ${count} coupons`,
    },
    xzxCouponList: {
      exchange: 'Exchange',
      close: 'Close',
      enable: 'Available',
      disabled: 'Unavailable',
      placeholder: 'Coupon code',
    },
    xzxAddressEdit: {
      area: 'Area',
      areaEmpty: 'Please select a receiving area',
      addressEmpty: 'Address can not be empty',
      addressDetail: 'Address',
      defaultAddress: 'Set as the default address',
    },
    xzxAddressList: {
      add: 'Add new address',
    },
  },
}
